


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { TabContext, TabList, TabPanel } from '@material-ui/lab';
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';

// function Table2() {
//   const [sheets, setSheets] = useState([]);
//   const [selectedSheet, setSelectedSheet] = useState(0);

//   useEffect(() => {
//     const fetchExcelData = async () => {
//       try {
//         const response = await axios.get('http://127.0.0.1:8000/api/v2/user_modules/api/serve-excel/'); // Use the correct URL for your Django API endpoint
//         const data = response.data;

//         setSheets(data);
//       } catch (error) {
//         console.error('Error fetching Excel data:', error);
//       }
//     };

//     fetchExcelData();
//   }, []);

//   const handleSheetClick = (index) => {
//     setSelectedSheet(index);
//   };

//   // Check if sheets is defined and contains at least one element
//   if (!sheets || sheets.length === 0) {
//     return <div>No data available</div>;
//   }

//   // Check if the selectedSheet is within the valid range
//   if (selectedSheet < 0 || selectedSheet >= sheets.length) {
//     setSelectedSheet(0);
//   }

//   const headers = sheets[selectedSheet][0];
//   const data = sheets[selectedSheet].slice(1);

//   // Convert data into an array of objects
//   const formattedData = data?.map((row) => {
//     const rowData = {};
//     headers.forEach((header, index) => {
//       rowData[header] = row[index];
//     });
//     return rowData;
//   });

//   console.log('formattedData', formattedData);

//   return (
//     <div>
//       <pre>{JSON.stringify(sheets[selectedSheet], null, 2)}</pre>
//       {sheets.length > 0 && (
//         <div>
//           <h2>Sheets:</h2>
//           <TabContext value={selectedSheet.toString()}>
//             <TabList
//               onChange={(e, newValue) => handleSheetClick(parseInt(newValue))}
//               aria-label="Sheets"
//             >
//               {sheets.map((sheet, index) => (
//                 <TabPanel value={index.toString()} key={index}>
//                   Sheet {index + 1}
//                 </TabPanel>
//               ))}
//             </TabList>
//           </TabContext>
//           <h2>Data:</h2>
//           <Paper>
//             <TableContainer>
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     {headers.map((header, index) => (
//                       <TableCell key={index}>{header}</TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {data.map((row, rowIndex) => (
//                     <TableRow key={rowIndex}>
//                       {row.map((cell, cellIndex) => (
//                         <TableCell key={cellIndex}>{cell}</TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </Paper>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Table2;

import React,{useEffect, useState,} from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { Grid, Button } from 'semantic-ui-react';

import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import axios from 'axios';  
import './excel_sheet.css';

import {getExcelSheetdata} from '../../../services/vrs/vrs';

import { AgGridReact } from 'ag-grid-react'; // Import Ag-Grid components
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { port } from '../../../services/auth-service/authService';

import { baseUrl } from "../../../services/common/credentials";

var local_host = baseUrl + port;


const StickyHeadTable3 = ({data}) => {
  const [page, setPage] = useState(0);
  const [tab, settab] = useState(0);
  const [formData, setFormData] = useState({});
  const [rowdata, setRowdata] = useState([]);
  const [columnnames, setcolumnnames] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formCreate, setFormCreate] = useState(true);
  const [formValues, setFormValues] = useState({
     })
    const [vrsdata, setvrsdata] = useState({});

    const OpenIntColumnDefs = React.useMemo(() => {
      if (rowdata?.length > 0) {
        // Get the column names from the first row of the JSON data
        const keys = Object.keys(rowdata[0]);
  
        // Create column definitions with the checkbox as the first column
        const intColumnDefs1 = [
          {
            headerCheckboxSelection: true, // Add this line for the checkbox selection
            checkboxSelection: true, // Add this line for the checkbox selection
            width: 20
          },
          ...keys.map((key) => ({
            headerName: key,
            field: key,
            sortable: true,
            filter: true,
            resizable: true
          })),
        ];
        setcolumnnames(intColumnDefs1);
        console.log('intColumnDefs', intColumnDefs1);
        return intColumnDefs1;
      }
      return [];
    }, [rowdata]);
    
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const formFields = Object.entries(formData).map(([label, value]) => {
      return (
        <div key={label} className="pb-3">
          <label className="label10" htmlFor={label}>{label}</label>
          {typeof value === 'string' ? (
            <input
              type="text"
              name={label}
              value={value}
              onChange={handleChange}
            />
          ) : typeof value === 'number' ? (
            <input
              type="number"
              name={label}
              value={value}
              onChange={handleChange}
            />
          ) : typeof value === 'boolean' ? (
            <input
              type="checkbox"
              name={label}
              checked={value}
              onChange={handleChange}
            />
          ) : typeof value === 'object' && value instanceof Date ? (
            <input
              type="date"
              name={label}
              value={value.toISOString().split('T')[0]}
              onChange={handleChange}
            />
          ) : (
            // Add more cases for other data types as needed
            <input
              type="text"
              name={label}
              value={value}
              onChange={handleChange}
            />
          )}
        </div>
      );
    });
    

    const fetchremarksinfo = () => {
      let sheet_id = '';
      let skip_rows = ''
      if(data == '1'){
        sheet_id = 0;
        skip_rows = 18 
      }
      else if(data == '2'){
        sheet_id = 1;
        skip_rows = 9
      }
      else if(data == '3'){
        sheet_id = 2;
        skip_rows = 4
      }

      else if(data == '4'){
        sheet_id = 3;
        skip_rows = 5
      }

      else if(data == '5'){
        sheet_id = 4;
        skip_rows = 5
      }
      else if(data == '6'){
        sheet_id = 5;
        skip_rows = 5
      }
      else if(data == '7'){
        sheet_id = 6;
        skip_rows = 5
      }
      else if(data == '8'){
        sheet_id = 7;
        skip_rows = 5
      }
      else if(data == '9'){
        sheet_id = 8;
        skip_rows = 5
      }
      else if(data == '10'){
        sheet_id = 9;
        skip_rows = 5
      }
      else if( data == '11'){
        sheet_id = 10;
        skip_rows = 5
      }
      else if( data == '12'){
        sheet_id = 11;
        skip_rows = 5
      }
      else if(data == '13'){
        sheet_id = 12;
        skip_rows = 2
      }
      else if(data == '14'){
        sheet_id = 13;
        skip_rows = 2
      }
      settab(data)
      let payload = {
        "sheet_id": sheet_id,
        'skip_rows':skip_rows
      }
  
      var getProcessingLayerData = getExcelSheetdata();
  
      return axios.post(getProcessingLayerData[1], payload, getProcessingLayerData[0])
        .then(
          response => {
            console.log("Processing Layer Data 123768!!!", response)
            let data = response["data"];
            setRowdata(data['rowdata']);
            let data1 = data['data']
            let index1 = data['index']
            const keyValueList = [];
            let rowdata = data['rowdata'];
            let json = {};
            setvrsdata(json);
            if(index1 == 2){
                console.log('rowdata', rowdata[1])
                json['1'] = rowdata[1]['Amount'];
                json['2'] = rowdata[3]['Amount'];
                json['3'] = rowdata[5]['Amount.1'];
                json['4'] = rowdata[9]['Amount'];
                json['5'] = rowdata[11]['Amount'];
                json['6'] = rowdata[13]['Amount'];
                json['7'] = rowdata[15]['Amount'];
                json['8'] = rowdata[17]['Amount'];
                json['9'] = rowdata[19]['Amount'];
                json['10'] = rowdata[21]['Amount'];
                json['11'] = rowdata[23]['Amount'];
                json['contra'] = rowdata[25]['Amount'];
                json['contra_total'] = rowdata[25]['Amount.1'];
                json['12'] = rowdata[27]['Amount'];
                json['13'] = rowdata[28]['Amount'];
                json['14'] = rowdata[29]['Amount'];
                json['15'] = rowdata[31]['Amount.1'];
                json['16'] = rowdata[33]['Amount.1'];
                json['17'] = rowdata[35]['Amount'];
                setvrsdata(json);
            }
            
          // Iterate through the JSON data
          for (let i = 0; i < data1.length; i++) {
            // Access each object in the JSON array
            const item = data1[i];

            // Iterate through the keys in each object
            for (const key in item) {
              if (item.hasOwnProperty(key)) {
                // Get the key and its corresponding value
                if (item[key] != '') {
                  // If it contains the value, append it to the array
                  keyValueList.push(item[key]);
                }
              }
            }
          }
          const keyValuePairs = {};

          setFormValues({});

        for (let i = 0; i < keyValueList.length; i += 2) {
          const key = keyValueList[i];
          const value = keyValueList[i + 1];
          keyValuePairs[key] = value;
        }
        setFormData(keyValuePairs);
          console.log('keyValueList', keyValueList, keyValuePairs, index1);
        if(index1 == 3 || index1 == 5 || index1 == 7){
          console.log('data1', data1[0])
          formValues['Depost_amount'] = data1[0]
          formValues['Credit_amount'] = data1[1]
          formValues['total_amount'] = data1[2]
        } else if(index1 == 4){
          console.log('data1', data1[0])
          formValues['Payment_made_by_Thermax_not_accounted_by_vendor'] = data1[0]
          
        }
        else if(index1 == 6){
          formValues['Debit_Note_raised_by_Thermax_not_accounted_by_Supplier'] = data1[0] 
        }
        else if(index1 == 8){
          formValues['Payment_received_by_vendor_but_not_accounted_by_Thermax'] = data1[0] 
        }
        else if(index1 == 9){
          formValues['Invoices_reconciled_with_value_differences'] = data1[0] 
        }

        else if(index1 == 10){
          formValues['Credit_Note_raised_by_Vendor_not_accounted_by_Thermax'] = data1[0] 
        }

        else if(index1 == 11){
          formValues['Depost_amount'] = data1[0]
          formValues['Credit_amount'] = data1[1] 
        }

        else if(index1 == 12 || index1 == 13){
          formValues['Closing_balance'] = data1[0]
          formValues['Opening_balance'] = data1[1] 
        }
         
        setFormValues(formValues);
        }
        ).catch(
          error => {
            console.log("Error in Processing Layer Data!!!", error);
          }
        );
  
    }
  
  useEffect(() => {
    // const url = local_host + `/api/v2/user_modules/api/excel_sheet/`;
    fetchremarksinfo();
  },[]);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };



  return (
    <>
    {
      tab != '14' ? (<><form>{formFields}</form></>):(<></>)
    }
    

    {
      tab == '4' || tab == '6' || tab == '8' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
      
      <div className="form-inline row">
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Total Debit</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Depost_amount || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Total Credit</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Credit_amount || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Balance</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.total_amount || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </div>
        </form>
      </>) : (<></>)
    }

    {
      tab == '5' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Payment made by Thermax not accounted by vendor</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Payment_made_by_Thermax_not_accounted_by_vendor || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}

        {
      tab == '7' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Debit Note raised by Thermax not accounted by Supplier</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Debit_Note_raised_by_Thermax_not_accounted_by_Supplier || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}
        {
      tab == '9' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Payment received by vendor but not accounted by Thermax</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Payment_received_by_vendor_but_not_accounted_by_Thermax || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}

        {
      tab == '10' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Invoices reconciled with value differences</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Invoices_reconciled_with_value_differences || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}
        {
      tab == '11' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Credit Note raised by Vendor not accounted by Thermax</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Credit_Note_raised_by_Vendor_not_accounted_by_Thermax || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}
        {
      tab == '12' ? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Deposit amount</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Depost_amount || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Credit amount</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Credit_amount || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}

        {
      tab == '13' || tab == '14'? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Opening balance</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Opening_balance || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group col-md-3 mb-2">
          <label className="label1 mb-1">Closing balance</label>
          <div className="input_group">
            <input type="number" name="task_id" className="resource_input" value={formValues && formValues.Closing_balance || 0} disabled={true} /><br /> <br />
          </div>
        </div>
        
        </form>
        </>):(<></>)}

        {
      tab == '3'? (<>
        <form style={{justifyContent:'center', marginBottom:'2em'}}>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Closing Balance as per THERMAX ONSITE ENERGY SOLUTIONS LTD</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['1']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Closing Balance as per Vendor</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['2']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Variance</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['3']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Purchase Invoices booked by Thermax not appearing/accounted by vendor</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['4']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Payment made by Thermax not accounted by vendor</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['5']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">TDS dedcuted by Thermax not accounted by Supplier</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['6']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Debit Note raised by Thermax not accounted by Supplier</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['7']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Sales considered by vendor but not accounted by Thermax</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['8']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Payment received by vendor but not accounted by Thermax</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['9']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Invoices reconciled with value differences </label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['10']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Credit Note raised by Vendor not accounted by Thermax</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['11']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Contra entries as per Thermax SOA</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['contra']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Annexure Total</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['contra_total']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Difference in Opening balance of Thermax & Vendor statement</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['12']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Opening balance as per Thermax </label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['13']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Opening balance as per Vendor</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['14']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Sum total of variance</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['15']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Check</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="number" name="task_id" className="resource_input" value={vrsdata && vrsdata['16']} disabled={true} /><br /> <br />
          </div>
        </div>
        <div className="form-group mb-2 row">
            <div className="col-md-6">
            <label className="label9 mb-1">Reconciliation done till</label>
            </div>
          
          <div className="input_group col-md-3">
            <input type="text" name="task_id" className="resource_input" value={vrsdata && vrsdata['17']} disabled={true} /><br /> <br />
          </div>
        </div>
        </form>
        </>):(<></>)}
{
   tab != '3' && rowdata.length > 0 ? (<>
        <div className="ag-theme-alpine col-md-5" style={{ height: '400px', width: '100%' }}>
            
            <AgGridReact columnDefs={columnnames} rowData={rowdata} animateRows={true}
              // rowSelection={'multiple'}
              pagination={true}
              paginationPageSize={10}
              groupSelectsChildren={true}
              suppressAggAtRootLevel={true}
              suppressRowClickSelection={true} />
          </div>
    </>):(<></>)
}
  
    </>
  );
}



const ResourceMasterTabs = () => {
  const [value, setValue] = useState("1");
  const [rowData, setRowData] = useState(undefined);
 
  const [hideResultGrid, setHideResultGrid] = useState(true);
  const [tab, setTab] = useState(null);
  
  const makeAPICall = async (url) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      console.log('data'+data);
      setRowData(data);
      setHideResultGrid(false);
      // setColumnData(gridColumnDefs);
      
    }
    catch (e) {
      console.log(e);
      setHideResultGrid(true);
    }
  }
 
  const handleChange = (event, newValue) => {
    
    setValue(newValue);
  };

  return (
    
    <Box>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", display: 'flex', justifyContent: 'flex-end',  overflow: 'auto'}}>
        <div style={{ overflow: 'auto', width: '100%' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" style={{overflow: 'auto'}}>
            <Tab label="Home" value="1" className="resource_input1"  sx={{color:'darkblue'}}/>
            <Tab label="Details" value="2" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Vrs" value="3" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 1" value="4" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 2" value="5" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 3" value="6" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 4" value="7" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 5" value="8" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 6" value="9" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 7" value="10" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 8" value="11" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Annexure 9" value="12" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Vendor statement" value="13" className="resource_input1" sx={{color:'darkblue'}} />
            <Tab label="Thermax statement" value="14" className="resource_input1" sx={{color:'darkblue'}} />
          </TabList>
          </div>
        </Box>
        <TabPanel value="1" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="2" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="3" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="4" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="5" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="6" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="7" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="8" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="9" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="10" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="11" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="12" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="13" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
        <TabPanel value="14" style={{backgroundColor:'white'}}><StickyHeadTable3 data={value}/></TabPanel>
      </TabContext>
    </Box>
    
  );
}



const ResourceMaster = () => {
 
  return (
    
     <div className="side" style={{ padding:"10px"}}>
     <Grid columns='equal'>
          <Grid.Row style={{ backgroundColor:"#fff",borderRadius:"12px",marginTop:"10px"}}>
          <Grid.Column>
              <ResourceMasterTabs />
          </Grid.Column>
          </Grid.Row> 
      </Grid>
     </div>
    
  );
}


export default ResourceMaster;